/** Prototype POPULAR_EMOJI — compose picker for posts/comments */
export const POPULAR_EMOJI = [
  '😀', '😂', '🤣', '😅', '😍', '😎', '🤔', '😤', '😡', '🥲', '😭', '🥹',
  '👍', '👎', '👏', '🙌', '🤝', '💪', '🤙', '🫡', '🙏', '✌️', '🤞', '👌',
  '🔥', '💯', '⚡', '✨', '🎉', '🏆', '🥇', '🥈', '🥉', '🎯', '💰', '💵',
  '⛳', '🏌️', '🏌️‍♀️', '🦅', '🌧️', '☀️', '🌤️', '💨', '🌪️', '🏖️', '🌴', '⛅',
  '🍺', '🍻', '🥃', '🍷', '☕', '🍔', '🌭', '🥪', '🍕', '🍟', '🥩', '🌮',
  '⚔️', '🛡️', '⚓', '✈️', '🚀', '🎖️', '⭐', '💥', '🎖', '🪖', '🏅', '🏵️',
] as const;
